<template>
  <main-layout>
    <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'ImpressionFacebook'" :href="'#ImpressionFacebook'">{{
        $t('Impression Facebook')
      }}</v-tab>
      <v-tab ripple :key="'ReachLine'" :href="'#ReachLine'">{{ $t('Reach LINE') }}</v-tab>
    </v-tabs>
    <div>
      <div v-if="tabs == 'ImpressionFacebook'">
        <ImpressionFacebook
          :groupOptions="groupOptions"
          :pageloading="pageloading"
          :channels="channels"
        ></ImpressionFacebook>
      </div>
      <div v-else-if="tabs == 'ReachLine'">
        <ReachLine
          :groupOptions="groupOptions"
          :pageloading="pageloading"
          :channels="channels"
        ></ReachLine>
      </div>
    </div>
  </main-layout>
</template>

<script>
import ImpressionFacebook from './ImpressionFacebook.vue'
import ReachLine from './ReachLine.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {
    ImpressionFacebook,
    ReachLine
  },
  data() {
    return {
      pageloading: false,
      tabs: 'ImpressionFacebook',
      channels: [],
      groupOptions: []
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.tabs = vm.$route.query.tab
    } else {
      vm.tabs = 'ImpressionFacebook'
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getChannel()
    this.getGroups()
  },
  methods: {
    getGroups() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.getPowerbuyGroup(data, (err, response) => {
        this.groupOptions = response.data
      })
    },
    getChannel() {
      var data = {
        pageid: this.selectedBot.pageid // pageid ที่เข้ามาจาก cms
      }

      this.pageloading = true
      api.powerbuyGetChannel(data, (err, response) => {
        this.pageloading = false
        this.channels = response.data
      })
    }
  },
  watch: {
    tabs: function () {
      //   this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Analytics/main.vue